import { offlineDb } from './offline-db'
import { generateClientUuid } from './uuid'

/**
 * @param {Object} payload - Serialized crash submit body
 * @param {import('./offline-db').IncidentLocalStatus} status
 */
export async function upsertLocalIncident(clientUuid, payload, status) {
  const now = new Date().toISOString()
  await offlineDb.localIncidents.put({
    clientUuid,
    payload,
    status,
    updatedAt: now
  })
}

export async function getLocalIncident(clientUuid) {
  return offlineDb.localIncidents.get(clientUuid)
}

export async function listLocalIncidents() {
  return offlineDb.localIncidents.toArray()
}

/**
 * @param {string} clientUuid
 * @param {string} serverFinalId
 */
export async function markIncidentSynced(clientUuid, serverFinalId) {
  const row = await offlineDb.localIncidents.get(clientUuid)
  if (!row) return
  await offlineDb.localIncidents.put({
    ...row,
    status: 'synced',
    serverFinalId,
    updatedAt: new Date().toISOString()
  })
}

export async function markIncidentExported(clientUuid) {
  const row = await offlineDb.localIncidents.get(clientUuid)
  if (!row) return
  await offlineDb.localIncidents.put({
    ...row,
    status: 'exported',
    updatedAt: new Date().toISOString()
  })
}

export { generateClientUuid }
